/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BatchOperationReqVo,
  ImageUploadReqVo,
  ProductBatchRegisterReqVo,
  ProductRegisterReqVo,
  ResponseBoolean,
  ResponseListBusinessPlatformResVo,
  ResponseListProductRegisterResVo,
  ResponseLong,
  ResponseProductListPageResVo,
  ResponseProductRegisterResVo,
  ResponseSkuBatchUploadResVo,
  ResponseSkuCompositionResVo,
  ResponseSkuProductResVo,
  ResponseSkuResVo,
  ResponseSkuStatisticsResVo,
  ResponseSpuResVo,
  ResponseString,
  SkuProductUpdateReqVo,
  SkuUpdateReqVo,
  SpuUpdateReqVo,
} from '../models/index';
import {
    BatchOperationReqVoFromJSON,
    BatchOperationReqVoToJSON,
    ImageUploadReqVoFromJSON,
    ImageUploadReqVoToJSON,
    ProductBatchRegisterReqVoFromJSON,
    ProductBatchRegisterReqVoToJSON,
    ProductRegisterReqVoFromJSON,
    ProductRegisterReqVoToJSON,
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    ResponseListBusinessPlatformResVoFromJSON,
    ResponseListBusinessPlatformResVoToJSON,
    ResponseListProductRegisterResVoFromJSON,
    ResponseListProductRegisterResVoToJSON,
    ResponseLongFromJSON,
    ResponseLongToJSON,
    ResponseProductListPageResVoFromJSON,
    ResponseProductListPageResVoToJSON,
    ResponseProductRegisterResVoFromJSON,
    ResponseProductRegisterResVoToJSON,
    ResponseSkuBatchUploadResVoFromJSON,
    ResponseSkuBatchUploadResVoToJSON,
    ResponseSkuCompositionResVoFromJSON,
    ResponseSkuCompositionResVoToJSON,
    ResponseSkuProductResVoFromJSON,
    ResponseSkuProductResVoToJSON,
    ResponseSkuResVoFromJSON,
    ResponseSkuResVoToJSON,
    ResponseSkuStatisticsResVoFromJSON,
    ResponseSkuStatisticsResVoToJSON,
    ResponseSpuResVoFromJSON,
    ResponseSpuResVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
    SkuProductUpdateReqVoFromJSON,
    SkuProductUpdateReqVoToJSON,
    SkuUpdateReqVoFromJSON,
    SkuUpdateReqVoToJSON,
    SpuUpdateReqVoFromJSON,
    SpuUpdateReqVoToJSON,
} from '../models/index';

export interface SkuBatchDeleteRequest {
    batchOperationReqVo?: BatchOperationReqVo;
}

export interface SkuBatchUploadPostRequest {
    file: Blob;
}

export interface SkuDetailSkuIdGetRequest {
    skuId: number;
}

export interface SkuDisablePostRequest {
    batchOperationReqVo?: BatchOperationReqVo;
}

export interface SkuEnablePostRequest {
    batchOperationReqVo?: BatchOperationReqVo;
}

export interface SkuExportGetRequest {
    keyword?: string;
    userId?: number;
    enable?: number;
}

export interface SkuImagePostRequest {
    imageUploadReqVo?: ImageUploadReqVo;
}

export interface SkuListGetRequest {
    currentPage?: number;
    pageSize?: number;
    enable?: number;
    userId?: number;
    businessPlatformId?: number;
    keyword?: string;
    skuCode?: string;
    userName?: string;
    userCode?: string;
    startTime?: string;
    endTime?: string;
}

export interface SkuPatchRequest {
    skuUpdateReqVo?: SkuUpdateReqVo;
}

export interface SkuProductDetailIdGetRequest {
    id: number;
}

export interface SkuProductPatchRequest {
    skuProductUpdateReqVo?: SkuProductUpdateReqVo;
}

export interface SkuProductsBySkuCodeGetRequest {
    skuCode: string;
}

export interface SkuRegisterBatchPostRequest {
    productBatchRegisterReqVo?: ProductBatchRegisterReqVo;
}

export interface SkuRegisterPostRequest {
    productRegisterReqVo?: ProductRegisterReqVo;
}

export interface SkuSkuIdProductsGetRequest {
    skuId: number;
}

export interface SkuSpuPatchRequest {
    spuUpdateReqVo?: SpuUpdateReqVo;
}

export interface SkuSpuSpuIdGetRequest {
    spuId: number;
}

export interface SkuStatisticsGetRequest {
    userId?: number;
}

/**
 * 
 */
export class SkuControllerApi extends runtime.BaseAPI {

    /**
     * 商品管理·批量删除商品（曾在订单中出现过的商品不允许删除）
     * 商品管理·批量删除商品（曾在订单中出现过的商品不允许删除）
     */
    async skuBatchDeleteRaw(requestParameters: SkuBatchDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/batch`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: BatchOperationReqVoToJSON(requestParameters['batchOperationReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 商品管理·批量删除商品（曾在订单中出现过的商品不允许删除）
     * 商品管理·批量删除商品（曾在订单中出现过的商品不允许删除）
     */
    async skuBatchDelete(requestParameters: SkuBatchDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.skuBatchDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·SKU批量上传（注册商品下单）
     * 客户端·SKU批量上传（注册商品下单）
     */
    async skuBatchUploadPostRaw(requestParameters: SkuBatchUploadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseSkuBatchUploadResVo>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling skuBatchUploadPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/sku/batch-upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseSkuBatchUploadResVoFromJSON(jsonValue));
    }

    /**
     * 客户端·SKU批量上传（注册商品下单）
     * 客户端·SKU批量上传（注册商品下单）
     */
    async skuBatchUploadPost(requestParameters: SkuBatchUploadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseSkuBatchUploadResVo> {
        const response = await this.skuBatchUploadPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·SKU批量上传模板下载
     * 客户端·SKU批量上传模板下载
     */
    async skuBatchUploadTemplateGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/batch-upload/template`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 客户端·SKU批量上传模板下载
     * 客户端·SKU批量上传模板下载
     */
    async skuBatchUploadTemplateGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.skuBatchUploadTemplateGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * SKU详情查询
     * SKU详情查询
     */
    async skuDetailSkuIdGetRaw(requestParameters: SkuDetailSkuIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseSkuResVo>> {
        if (requestParameters['skuId'] == null) {
            throw new runtime.RequiredError(
                'skuId',
                'Required parameter "skuId" was null or undefined when calling skuDetailSkuIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/detail/{skuId}`.replace(`{${"skuId"}}`, encodeURIComponent(String(requestParameters['skuId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseSkuResVoFromJSON(jsonValue));
    }

    /**
     * SKU详情查询
     * SKU详情查询
     */
    async skuDetailSkuIdGet(requestParameters: SkuDetailSkuIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseSkuResVo> {
        const response = await this.skuDetailSkuIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 批量下架商品
     * 批量下架商品
     */
    async skuDisablePostRaw(requestParameters: SkuDisablePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/disable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BatchOperationReqVoToJSON(requestParameters['batchOperationReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 批量下架商品
     * 批量下架商品
     */
    async skuDisablePost(requestParameters: SkuDisablePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.skuDisablePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 批量上架商品
     * 批量上架商品
     */
    async skuEnablePostRaw(requestParameters: SkuEnablePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/enable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BatchOperationReqVoToJSON(requestParameters['batchOperationReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 批量上架商品
     * 批量上架商品
     */
    async skuEnablePost(requestParameters: SkuEnablePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.skuEnablePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 导出SPU/SKU文档
     * 导出SPU/SKU文档
     */
    async skuExportGetRaw(requestParameters: SkuExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 导出SPU/SKU文档
     * 导出SPU/SKU文档
     */
    async skuExportGet(requestParameters: SkuExportGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.skuExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 修改SPU/SKU/SKU_PRODUCT商品图片
     * 修改SPU/SKU/SKU_PRODUCT商品图片
     */
    async skuImagePostRaw(requestParameters: SkuImagePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/image`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImageUploadReqVoToJSON(requestParameters['imageUploadReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 修改SPU/SKU/SKU_PRODUCT商品图片
     * 修改SPU/SKU/SKU_PRODUCT商品图片
     */
    async skuImagePost(requestParameters: SkuImagePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.skuImagePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 商品列表分页查询
     * 商品列表分页查询
     */
    async skuListGetRaw(requestParameters: SkuListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseProductListPageResVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['businessPlatformId'] != null) {
            queryParameters['businessPlatformId'] = requestParameters['businessPlatformId'];
        }

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseProductListPageResVoFromJSON(jsonValue));
    }

    /**
     * 商品列表分页查询
     * 商品列表分页查询
     */
    async skuListGet(requestParameters: SkuListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseProductListPageResVo> {
        const response = await this.skuListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取第三方电商平台列表
     * 获取第三方电商平台列表
     */
    async skuMarketTypesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListBusinessPlatformResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/market-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListBusinessPlatformResVoFromJSON(jsonValue));
    }

    /**
     * 获取第三方电商平台列表
     * 获取第三方电商平台列表
     */
    async skuMarketTypesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListBusinessPlatformResVo> {
        const response = await this.skuMarketTypesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * SKU信息更新（管理端可修改SKU编码，编码需全局唯一）
     * SKU信息更新（管理端可修改SKU编码，编码需全局唯一）
     */
    async skuPatchRaw(requestParameters: SkuPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SkuUpdateReqVoToJSON(requestParameters['skuUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * SKU信息更新（管理端可修改SKU编码，编码需全局唯一）
     * SKU信息更新（管理端可修改SKU编码，编码需全局唯一）
     */
    async skuPatch(requestParameters: SkuPatchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.skuPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * SKU商品详情查询
     * SKU商品详情查询
     */
    async skuProductDetailIdGetRaw(requestParameters: SkuProductDetailIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseSkuProductResVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling skuProductDetailIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/product/detail/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseSkuProductResVoFromJSON(jsonValue));
    }

    /**
     * SKU商品详情查询
     * SKU商品详情查询
     */
    async skuProductDetailIdGet(requestParameters: SkuProductDetailIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseSkuProductResVo> {
        const response = await this.skuProductDetailIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * SKU商品信息更新
     * SKU商品信息更新
     */
    async skuProductPatchRaw(requestParameters: SkuProductPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/product`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SkuProductUpdateReqVoToJSON(requestParameters['skuProductUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * SKU商品信息更新
     * SKU商品信息更新
     */
    async skuProductPatch(requestParameters: SkuProductPatchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.skuProductPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取SKU商品构成（按SKU编码）
     * 获取SKU商品构成（按SKU编码）
     */
    async skuProductsBySkuCodeGetRaw(requestParameters: SkuProductsBySkuCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseSkuCompositionResVo>> {
        if (requestParameters['skuCode'] == null) {
            throw new runtime.RequiredError(
                'skuCode',
                'Required parameter "skuCode" was null or undefined when calling skuProductsBySkuCodeGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/products/by-sku-code`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseSkuCompositionResVoFromJSON(jsonValue));
    }

    /**
     * 获取SKU商品构成（按SKU编码）
     * 获取SKU商品构成（按SKU编码）
     */
    async skuProductsBySkuCodeGet(requestParameters: SkuProductsBySkuCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseSkuCompositionResVo> {
        const response = await this.skuProductsBySkuCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 商品管理·批量注册（批量拉取平台商品并生成可编辑的SKU注册草稿）
     * 商品管理·批量注册（批量拉取平台商品并生成可编辑的SKU注册草稿）
     */
    async skuRegisterBatchPostRaw(requestParameters: SkuRegisterBatchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListProductRegisterResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/register/batch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductBatchRegisterReqVoToJSON(requestParameters['productBatchRegisterReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListProductRegisterResVoFromJSON(jsonValue));
    }

    /**
     * 商品管理·批量注册（批量拉取平台商品并生成可编辑的SKU注册草稿）
     * 商品管理·批量注册（批量拉取平台商品并生成可编辑的SKU注册草稿）
     */
    async skuRegisterBatchPost(requestParameters: SkuRegisterBatchPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListProductRegisterResVo> {
        const response = await this.skuRegisterBatchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 商品管理·商品注册
     * 商品管理·商品注册
     */
    async skuRegisterPostRaw(requestParameters: SkuRegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseProductRegisterResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductRegisterReqVoToJSON(requestParameters['productRegisterReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseProductRegisterResVoFromJSON(jsonValue));
    }

    /**
     * 商品管理·商品注册
     * 商品管理·商品注册
     */
    async skuRegisterPost(requestParameters: SkuRegisterPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseProductRegisterResVo> {
        const response = await this.skuRegisterPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取SKU商品构成
     * 获取SKU商品构成
     */
    async skuSkuIdProductsGetRaw(requestParameters: SkuSkuIdProductsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseSkuCompositionResVo>> {
        if (requestParameters['skuId'] == null) {
            throw new runtime.RequiredError(
                'skuId',
                'Required parameter "skuId" was null or undefined when calling skuSkuIdProductsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/{skuId}/products`.replace(`{${"skuId"}}`, encodeURIComponent(String(requestParameters['skuId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseSkuCompositionResVoFromJSON(jsonValue));
    }

    /**
     * 获取SKU商品构成
     * 获取SKU商品构成
     */
    async skuSkuIdProductsGet(requestParameters: SkuSkuIdProductsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseSkuCompositionResVo> {
        const response = await this.skuSkuIdProductsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * SPU信息更新
     * SPU信息更新
     */
    async skuSpuPatchRaw(requestParameters: SkuSpuPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/spu`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SpuUpdateReqVoToJSON(requestParameters['spuUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * SPU信息更新
     * SPU信息更新
     */
    async skuSpuPatch(requestParameters: SkuSpuPatchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.skuSpuPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * SPU详情查询
     * SPU详情查询
     */
    async skuSpuSpuIdGetRaw(requestParameters: SkuSpuSpuIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseSpuResVo>> {
        if (requestParameters['spuId'] == null) {
            throw new runtime.RequiredError(
                'spuId',
                'Required parameter "spuId" was null or undefined when calling skuSpuSpuIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/spu/{spuId}`.replace(`{${"spuId"}}`, encodeURIComponent(String(requestParameters['spuId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseSpuResVoFromJSON(jsonValue));
    }

    /**
     * SPU详情查询
     * SPU详情查询
     */
    async skuSpuSpuIdGet(requestParameters: SkuSpuSpuIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseSpuResVo> {
        const response = await this.skuSpuSpuIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 【管理端】·商品统计
     * 【管理端】·商品统计
     */
    async skuStatisticsGetRaw(requestParameters: SkuStatisticsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseSkuStatisticsResVo>> {
        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/statistics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseSkuStatisticsResVoFromJSON(jsonValue));
    }

    /**
     * 【管理端】·商品统计
     * 【管理端】·商品统计
     */
    async skuStatisticsGet(requestParameters: SkuStatisticsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseSkuStatisticsResVo> {
        const response = await this.skuStatisticsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 系统平台使用独立接口，避免改变既有电商平台下拉的返回语义。 管理端·获取系统级API平台列表
     * 管理端·获取系统级API平台列表
     */
    async skuSystemPlatformsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListBusinessPlatformResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sku/system-platforms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListBusinessPlatformResVoFromJSON(jsonValue));
    }

    /**
     * 系统平台使用独立接口，避免改变既有电商平台下拉的返回语义。 管理端·获取系统级API平台列表
     * 管理端·获取系统级API平台列表
     */
    async skuSystemPlatformsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListBusinessPlatformResVo> {
        const response = await this.skuSystemPlatformsGetRaw(initOverrides);
        return await response.value();
    }

}
